import { EtypPrilohy } from 'enums/dokumentyEnums';

export const typPrilohySelect = [
    {
        value: EtypPrilohy.VYPISOR,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISOR'
    },
    {
        value: EtypPrilohy.VYPISORZMEN,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZMEN'
    },
    {
        value: EtypPrilohy.VYPISORZAPVYS,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZAPVYS'
    },
    {
        value: EtypPrilohy.VYPISOREMISAKC,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISOREMISAKC'
    },
    {
        value: EtypPrilohy.VYPISORLIKVID,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORLIKVID'
    },
    {
        value: EtypPrilohy.VYPISORJMENLIKVID,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORJMENLIKVID'
    },
    {
        value: EtypPrilohy.VYPISORNOVAFORMA,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORNOVAFORMA'
    },
    {
        value: EtypPrilohy.VYPISORZRUS,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZRUS'
    },
    {
        value: EtypPrilohy.VYPISORZAPZMENVH,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZAPZMENVH'
    },
    {
        value: EtypPrilohy.VYPISORZAPZMEN,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_VYPISORZAPZMEN'
    },
    {
        value: EtypPrilohy.ZAPISSCHUZVL,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_ZAPISSCHUZVL'
    },
    {
        value: EtypPrilohy.PROSPEKT,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_PROSPEKT'
    },
    {
        value: EtypPrilohy.DLUHPROG,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_DLUHPROG'
    },
    {
        value: EtypPrilohy.STATUTCNB,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_STATUTCNB'
    },
    {
        value: EtypPrilohy.ROZHODNUTICNB,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_ROZHODNUTICNB'
    },
    {
        value: EtypPrilohy.EMISNIPODMINKY,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_EMISNIPODMINKY'
    },
    {
        value: EtypPrilohy.EMISNIPODJINY,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_EMISNIPODJINY'
    },
    {
        value: EtypPrilohy.KUPONY,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_KUPONY'
    },
    {
        value: EtypPrilohy.PROJEKTPREMENY,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_PROJEKTPREMENY'
    },
    {
        value: EtypPrilohy.PROJEKTFUZE,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_PROJEKTFUZE'
    },
    {
        value: EtypPrilohy.OPRAVNENIPODANIPOZ,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_OPRAVNENIPODANIPOZ'
    },
    {
        value: EtypPrilohy.JINYOPRAVNENIZMENY,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_JINYOPRAVNENIZMENY'
    },
    {
        value: EtypPrilohy.JINYJMENUJLIKVID,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_JINYJMENUJLIKVID'
    },
    {
        value: EtypPrilohy.STANOVY,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_STANOVY'
    },
    {
        value: EtypPrilohy.JINY,
        labelcz: 'DOKUMENT_DODATEK_DETAIL_PRILOHY_JINY'
    }
];

export default typPrilohySelect;
